import { render, staticRenderFns } from "./SOVReport.vue?vue&type=template&id=1f5211e5&scoped=true"
import script from "./SOVReport.vue?vue&type=script&lang=js"
export * from "./SOVReport.vue?vue&type=script&lang=js"
import style0 from "./SOVReport.vue?vue&type=style&index=0&id=1f5211e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5211e5",
  null
  
)

export default component.exports